import React from 'react'
import '../styles/sidebar-icon-link.css'

export const SidebarIconTitle: React.FC = (props) => {
  return <span className="sidebar-icon-link">{props.children}</span>
}
